import type { RuntimeBranding } from '@/auth/runtime-config';
import { lockLightMode, unlockLightMode } from '@/lib/theme';

const PRODUCT_SUFFIX = 'Admin';

interface Branding {
  appName: string | null;
  logoUrl: string | null;
}

let current: Branding = { appName: null, logoUrl: null };

function textOrNull(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

function sameOriginPath(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/')) return null;
  try {
    const url = new URL(value, window.location.origin);
    return url.origin === window.location.origin ? `${url.pathname}${url.search}` : null;
  } catch {
    return null;
  }
}

function setFavicon(url: string): void {
  const icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!icon) return;
  icon.type = 'image/png';
  icon.href = url;
}

export function applyBranding(raw: RuntimeBranding | null | undefined): void {
  current = { appName: textOrNull(raw?.appName), logoUrl: sameOriginPath(raw?.logoUrl) };
  if (raw?.hasDarkPalette === false) lockLightMode();
  else unlockLightMode();
  if (current.appName) document.title = `${current.appName} ${PRODUCT_SUFFIX}`;
  if (current.logoUrl) setFavicon(current.logoUrl);
}

export function brandName(): { prefix: string; suffix: string } {
  return { prefix: current.appName ? `${current.appName} ` : 'Echo', suffix: PRODUCT_SUFFIX };
}

export function brandLogoUrl(): string | null {
  return current.logoUrl;
}
